import email from './email';

export default email;
